import { useQueryClient } from '@tanstack/react-query';
import type { GetProcessDraftResponse } from '@bliks-io/contracts';
import { undoDraftApi, redoDraftApi } from '../../persist/draft';
import { useDraftMutation } from '../helpers/draftMutation';
import { processDraftKeys } from '../../query-keys';

/**
 * Persistent undo/redo (ADR 0007). Server-authoritative: each call steps the
 * draft one history entry and returns the full draft envelope, which we swap
 * into the cache for an instant update. `useDraftMutation`'s settle-invalidate
 * then refetches the draft AND the draft-scoped layout, converging positions
 * that aren't carried on the draft response.
 */
export function useUndoDraft(processId: string) {
  const queryClient = useQueryClient();
  return useDraftMutation(processId, {
    mutationFn: (): Promise<GetProcessDraftResponse> => undoDraftApi(processId),
    onSuccess: (data) => {
      queryClient.setQueryData(processDraftKeys.detail(processId), data);
    }
  });
}

export function useRedoDraft(processId: string) {
  const queryClient = useQueryClient();
  return useDraftMutation(processId, {
    mutationFn: (): Promise<GetProcessDraftResponse> => redoDraftApi(processId),
    onSuccess: (data) => {
      queryClient.setQueryData(processDraftKeys.detail(processId), data);
    }
  });
}
